import type { Account } from 'pkg/api/models/account';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Author } from 'pkg/api/models/author';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Group } from 'pkg/api/models/group';
import type { Record } from 'pkg/api/models/record';
import type { VideoSequence } from 'pkg/api/models/video_sequence';

export interface VideoPlaylistVideoSequence extends Record, Dateable {
	videoPlaylistId: number;
	videoSequenceId: number;
	order: number;
	videoSequence?: VideoSequence;
}

export enum VideoPlaylistSequencePermissions {
	GroupMember = 'groupMember',
	GroupAdmin = 'groupAdmin',
}

export type VideoPlaylistPermission =
	| 'only_you'
	| 'group_admins'
	| 'group_members';

export interface VideoPlaylist extends Record, Dateable, AllowedActionable {
	accountId: number;
	account: Account;
	author?: Author;
	groupId: number;
	group: Group;
	title: string;
	isPrivate: boolean;
	sequences?: VideoPlaylistVideoSequence[];
	sequenceCount?: number;
	sequencePermissions?: VideoPlaylistSequencePermissions[];
}

export interface VideoPlaylistCreatePayload {
	title: string;
	groupId: number;
	sequencePermissions: VideoPlaylistSequencePermissions[];
}
